module.exports = __webpack_public_path__ + "static/img/cy.d069616c.svg";